module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "components-container"
  }, [_c('div', {
    staticClass: "filter-container"
  }, [_c('div'), _vm._v(" "), _c('div', [_c('el-select', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "placeholder": "专业",
      "clearable": ""
    },
    model: {
      value: (_vm.queryForm.zy),
      callback: function($$v) {
        _vm.$set(_vm.queryForm, "zy", $$v)
      },
      expression: "queryForm.zy"
    }
  }, _vm._l((_vm.comboOption.major), function(item, index) {
    return _c('el-option', {
      key: item.comboValue,
      attrs: {
        "label": item.comboName,
        "value": item.comboValue
      }
    })
  }), 1), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "placeholder": "教师/工号",
      "clearable": ""
    },
    model: {
      value: (_vm.queryForm.jsxm),
      callback: function($$v) {
        _vm.$set(_vm.queryForm, "jsxm", $$v)
      },
      expression: "queryForm.jsxm"
    }
  }), _vm._v(" "), _c('el-select', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "placeholder": "指导状态",
      "clearable": ""
    },
    model: {
      value: (_vm.queryForm.zdzt),
      callback: function($$v) {
        _vm.$set(_vm.queryForm, "zdzt", $$v)
      },
      expression: "queryForm.zdzt"
    }
  }, _vm._l((_vm.comboOption.zdzt), function(item, index) {
    return _c('el-option', {
      key: item.comboValue,
      attrs: {
        "label": item.comboName,
        "value": item.comboValue
      }
    })
  }), 1), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "type": "gray"
    },
    on: {
      "click": _vm.queryList
    }
  }, [_c('i', {
    staticClass: "el-icon-search"
  }), _vm._v(" 查询")])], 1)]), _vm._v(" "), _c('el-table', {
    ref: "mainTable",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tableData,
      "element-loading-text": "数据加载中",
      "stripe": "",
      "border": "",
      "fit": "",
      "highlight-current-row": "",
      "height": 500
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "序号",
      "width": "60px",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s((_vm.queryForm.pageNum - 1) * _vm.queryForm.rowNum + scope.$index + 1))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "专业",
      "prop": "zy",
      "align": "center",
      "formatter": _vm.zyFormatter
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "工号",
      "prop": "gh",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "教师",
      "prop": "jsxm",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "指导状态",
      "prop": "zdzt",
      "align": "center",
      "formatter": _vm.zdztFormatter,
      "width": "150px"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "align": "center",
      "width": "100px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "small",
            "type": "warning"
          },
          on: {
            "click": function($event) {
              return _vm.editRec(scope.row);
            }
          }
        }, [_c('i', {
          staticClass: "el-icon-edit"
        }), _vm._v(" 编辑\n                    ")])]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "pagination-container"
  }, [_c('el-pagination', {
    attrs: {
      "current-page": _vm.queryForm.pageNum,
      "page-sizes": [10, 20, 50],
      "page-size": _vm.queryForm.rowNum,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.total
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange,
      "update:currentPage": function($event) {
        return _vm.$set(_vm.queryForm, "pageNum", $event)
      },
      "update:current-page": function($event) {
        return _vm.$set(_vm.queryForm, "pageNum", $event)
      }
    }
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.dialogTitle,
      "visible": _vm.dialogVisible,
      "width": "800px",
      "append-to-body": true
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      },
      "closed": _vm.closeDialog
    }
  }, [_c('el-form', {
    ref: "curdForm",
    staticClass: "small-space",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "model": _vm.curdForm,
      "rules": _vm.rules,
      "label-position": "left",
      "label-width": "110px"
    }
  }, [_c('el-row', {
    staticStyle: {
      "margin-bottom": "-10px"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "工号",
      "prop": "stuCode"
    }
  }, [_vm._v(_vm._s(_vm.curdForm.gh))])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "教师",
      "prop": "stuName"
    }
  }, [_vm._v(_vm._s(_vm.curdForm.jsxm))])], 1)], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "margin-bottom": "-10px"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "专业",
      "prop": "zy"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "220px"
    },
    attrs: {
      "placeholder": "专业",
      "clearable": ""
    },
    model: {
      value: (_vm.curdForm.zy),
      callback: function($$v) {
        _vm.$set(_vm.curdForm, "zy", $$v)
      },
      expression: "curdForm.zy"
    }
  }, _vm._l((_vm.comboOption.major), function(item, index) {
    return _c('el-option', {
      key: item.comboValue,
      attrs: {
        "label": item.comboName,
        "value": item.comboValue
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "指导状态",
      "prop": "zdzt"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.curdForm.zdzt),
      callback: function($$v) {
        _vm.$set(_vm.curdForm, "zdzt", $$v)
      },
      expression: "curdForm.zdzt"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "1"
    }
  }, [_vm._v("可选")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "0"
    }
  }, [_vm._v("不可选")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "align": "right"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("保存")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialogVisible = false
      }
    }
  }, [_vm._v("取消")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-79fee7d9"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/scoreManage/register/Instructor.vue
// module id = 1871
// module chunks = 502